import React from 'react';
import PrintRenderCounselingFollowUp from './soapNoteTemplateData/PrintRenderCounselingFollowUp';
import PrintRenderConsultation from './soapNoteTemplateData/PrintRenderConsultation';
import PrintRenderBioPsychoSocial from './soapNoteTemplateData/PrintRenderBioPsychoSocial';
import PrintCustomCounselling from './soapNoteTemplateData/PrintCustomCounselling';
import PrintRenderSoapNotePopUp from './soapNoteTemplateData/PrintRenderSoapNotePopUp';
import PrintFooter from '../Layouts/PrintFooter';

function CounselingPrintPopup({ allData, template }) {
  let demoData;
  let genData;

  for (const key in allData?.progressNoteItem) {
    if (allData?.progressNoteItem[key]?.variable_name === 'demographics') {
      for (const subKey in allData?.defaultSaveItem) {
        if (subKey === allData?.progressNoteItem[key]?.id) {
          demoData = allData?.defaultSaveItem[subKey]?.demographics;
          break;
        }
      }
    }
    if (allData?.progressNoteItem[key]?.variable_name === 'general_detail') {
      for (const subKey in allData?.defaultSaveItem) {
        if (subKey === allData?.progressNoteItem[key]?.id) {
          genData = allData?.defaultSaveItem[subKey]?.genDetail;
          break;
        }
      }
    }
  }
  return (
    <>
      <table
        width="734px"
        align="left"
        valign="top"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ fontSize: 14, marginBottom: 20 }}
      >
        <tbody>
          <tr width="734px">
            <td
              align="center"
              width="734px"
              style={{ fontSize: 21, color: '#000' }}
            >
              {template}
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="734px"
        cellSpacing={0}
        cellPadding={0}
        border={0}
        align="center"
        style={{ paddingBottom: 10 }}
      >
        <tbody>
          <tr width="734px">
            <td width="407px" style={{ paddingTop: 10 }} valign="top">
              <table
                width="407px"
                align="left"
                border={0}
                cellSpacing={0}
                cellPadding={0}
              >
                <tbody>
                  <tr width="407px">
                    <td valign="top" width="407px" style={{ fontSize: 19 }}>
                      {`${demoData?.patientName}  (${demoData?.chartNo})`}
                    </td>
                  </tr>
                  <tr width="407px">
                    <td valign="top" width="407px" style={{ paddingTop: 10 }}>
                      {demoData?.age} {demoData?.gender} DoB: {demoData?.dob}
                    </td>
                  </tr>
                  <tr width="407px">
                    <td valign="top" width="407px" style={{ paddingTop: 10 }}>
                      {demoData?.address}
                    </td>
                  </tr>
                  <tr width="407px">
                    <td valign="top" width="407px" style={{ paddingTop: 10 }}>
                      {demoData?.email} <b>{demoData?.phoneLabel}</b>
                      {': '}
                      {demoData?.phone}
                    </td>
                  </tr>
                  <tr width="407px">
                    <td valign="top" width="407px" style={{ paddingTop: 10 }}>
                      <b>Race:</b> {demoData?.race}, <b>Ethnicity:</b>{' '}
                      {demoData?.ethincity}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            {genData && (
              <td width="327px" style={{ paddingTop: 10 }} valign="top">
                <table
                  width="327px"
                  align="left"
                  border={0}
                  cellSpacing={0}
                  cellPadding={0}
                  valign="top"
                >
                  <tbody>
                    <tr rowSpan={2} width="327px">
                      <td valign="top" width="127px" style={{ paddingTop: 0 }}>
                        <b>Provider:</b>
                      </td>
                      <td valign="top" width="200px" style={{ paddingTop: 0 }}>
                        {genData?.resource}
                      </td>
                    </tr>
                    <tr rowSpan={2} width="327px">
                      <td valign="top" width="127px" style={{ paddingTop: 7 }}>
                        <b>Supervisor:</b>
                      </td>
                      <td valign="top" width="200px" style={{ paddingTop: 7 }}>
                        {genData?.supervisor}
                      </td>
                    </tr>
                    <tr rowSpan={2} width="327px">
                      <td valign="top" width="127px" style={{ paddingTop: 7 }}>
                        <b>Date of service:</b>
                      </td>
                      <td valign="top" width="200px" style={{ paddingTop: 7 }}>
                        {genData?.dos}
                      </td>
                    </tr>
                    <tr rowSpan={2} width="327px">
                      <td valign="top" width="127px" style={{ paddingTop: 7 }}>
                        <b>Time:</b>
                      </td>
                      <td valign="top" width="200px" style={{ paddingTop: 7 }}>
                        {genData?.consultTime}
                      </td>
                    </tr>
                    <tr rowSpan={2} width="327px">
                      <td valign="top" width="127px" style={{ paddingTop: 7 }}>
                        <b>Duration:</b>
                      </td>
                      <td valign="top" width="200px" style={{ paddingTop: 7 }}>
                        {genData?.duration}
                      </td>
                    </tr>
                    <tr rowSpan={2} width="327px">
                      <td valign="top" width="127px" style={{ paddingTop: 7 }}>
                        <b>Type:</b>
                      </td>
                      <td valign="top" width="200px" style={{ paddingTop: 7 }}>
                        {genData?.type}
                      </td>
                    </tr>
                    <tr rowSpan={2} width="327px">
                      <td valign="top" width="127px" style={{ paddingTop: 7 }}>
                        <b>Location:</b>
                      </td>
                      <td valign="top" width="200px" style={{ paddingTop: 7 }}>
                        {genData?.location}
                      </td>
                    </tr>
                    <tr rowSpan={2} width="327px">
                      <td valign="top" width="127px" style={{ paddingTop: 7 }}>
                        <b>Referral Source:</b>
                      </td>
                      <td valign="top" width="200px" style={{ paddingTop: 7 }}>
                        {genData?.referrer}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            )}
          </tr>
        </tbody>
      </table>
      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontSize: 14, fontWeight: 'bold', color: '#000' }}
              align="left"
            >
              Service code:
            </th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{ color: '#000', paddingTop: 5, paddingLeft: 15 }}
            >
              {genData &&
                genData?.procName?.map((data, i) => (
                  <div key={i}>
                    <div>{data.procName}</div>
                    <div>Unit: {data.unit}</div>
                  </div>
                ))}
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontSize: 14, fontWeight: 'bold', color: '#000' }}
              align="left"
            >
              Modifier:
            </th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{ color: '#000', paddingTop: 5, paddingLeft: 15 }}
            >
              {genData?.modifier?.split(',')?.join(', ')}
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontSize: 14, fontWeight: 'bold', color: '#000' }}
              align="left"
            >
              Diagnosis:
            </th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{ color: '#000', paddingTop: 5, paddingLeft: 15 }}
            >
              {genData && genData?.probText}
            </td>
          </tr>
        </tbody>
      </table>
      {(genData?.qcodeDetail ||
        genData?.patientLocation ||
        genData?.locationAddress ||
        genData?.providerLocation ||
        genData?.pfa_provider_loc ||
        genData?.pfc_telemedicine) && (
        <table
          width="734px"
          align="left"
          border={0}
          cellSpacing={0}
          cellPadding={0}
          style={{ marginTop: 15 }}
        >
          <tbody>
            <tr width="734px">
              <td
                width="719px"
                style={{ color: '#000', paddingTop: 5, paddingLeft: 15 }}
              >
                <span className="frst-sec-val sec-colr">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: genData?.qcodeDetail ? genData?.qcodeDetail : '',
                    }}
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: genData?.patientLocation
                        ? genData?.patientLocation
                        : '',
                    }}
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: genData?.locationAddress
                        ? genData?.locationAddress
                        : '',
                    }}
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: genData?.providerLocation
                        ? genData?.providerLocation
                        : '',
                    }}
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: genData?.pfa_provider_loc
                        ? genData?.pfa_provider_loc
                        : '',
                    }}
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: genData?.pfc_telemedicine
                        ? genData?.pfc_telemedicine
                        : '',
                    }}
                  />
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      )}

      {allData?.progressNoteItem &&
        allData?.progressNoteItem?.map((item, i) => {
          if (item?.itemLink !== 'hide') {
            return (
              <div
                className={
                  item?.itemLink === 'hide'
                    ? 'hide'
                    : 'sectionBlock smart-tag-sec'
                }
                key={i}
                id={'sectionName_' + item?.variable_name}
                value={item?.id}
              >
                {/* <div className="smart-tag-add-rem">
                    <span
                      className="smart-tag-name"
                      onClick={() => handleSoapItemPopup(item?.variable_name)}
                      id={'sectionId_' + item?.id}
                    >
                      {item?.preferred_label}
                    </span>
                    <span className="smart-tag-rem">[X]</span>
                  </div> */}
                {(item?.variable_name === 'follow-up-counseling' && (
                  <PrintRenderCounselingFollowUp
                    data={allData?.defaultSaveItem[item?.id]}
                    id={item?.id}
                  />
                )) ||
                  (item?.variable_name === 'biopsychosocial_intake' && (
                    <PrintRenderBioPsychoSocial
                      data={allData?.defaultSaveItem[item?.id]}
                      id={item?.id}
                    />
                  )) ||
                  (item?.variable_name === 'consultation' &&
                    item?.itemLink === 'show' && (
                      <PrintRenderConsultation
                        data={allData?.defaultSaveItem[item?.id]}
                        id={item?.id}
                      />
                    )) ||
                  (item?.variable_name === 'custom_counseling1' &&
                    item?.itemLink === 'show' && (
                      <PrintCustomCounselling
                        data={
                          allData?.defaultSaveItem[item?.id]
                            ?.renderCustomCounselingOneData
                        }
                        id={item?.id}
                      />
                    )) ||
                  (item?.variable_name === 'custom_counseling2' &&
                    item?.itemLink === 'show' && (
                      <PrintCustomCounselling
                        data={
                          allData?.defaultSaveItem[item?.id]
                            ?.renderCustomCounselingTwoData
                        }
                        id={item?.id}
                      />
                    )) ||
                  (item?.variable_name === 'custom_counseling3' &&
                    item?.itemLink === 'show' && (
                      <PrintCustomCounselling
                        data={
                          allData?.defaultSaveItem[item?.id]
                            ?.renderCustomCounselingThreeData
                        }
                        id={item?.id}
                      />
                    )) ||
                  (item?.variable_name === 'custom_counseling4' &&
                    item?.itemLink === 'show' && (
                      <PrintCustomCounselling
                        data={
                          allData?.defaultSaveItem[item?.id]
                            ?.renderCustomCounselingFourData
                        }
                        id={item?.id}
                      />
                    )) ||
                  (item?.variable_name === 'custom_counseling5' &&
                    item?.itemLink === 'show' && (
                      <PrintCustomCounselling
                        data={
                          allData?.defaultSaveItem[item?.id]
                            ?.renderCustomCounselingFiveData
                        }
                        id={item?.id}
                      />
                    )) ||
                  (item?.variable_name === 'custom_counseling6' &&
                    item?.itemLink === 'show' && (
                      <PrintCustomCounselling
                        data={
                          allData?.defaultSaveItem[item?.id]
                            ?.renderCustomCounselingSixData
                        }
                        id={item?.id}
                      />
                    )) ||
                  (item?.variable_name === 'custom_counseling7' &&
                    item?.itemLink === 'show' && (
                      <PrintCustomCounselling
                        data={
                          allData?.defaultSaveItem[item?.id]
                            ?.renderCustomCounselingSevenData
                        }
                        id={item?.id}
                      />
                    )) ||
                  (item?.variable_name === 'custom_counseling8' &&
                    item?.itemLink === 'show' && (
                      <PrintCustomCounselling
                        data={
                          allData?.defaultSaveItem[item?.id]
                            ?.renderCustomCounselingEightData
                        }
                        id={item?.id}
                      />
                    )) ||
                  (item?.variable_name === 'custom_counseling9' &&
                    item?.itemLink === 'show' && (
                      <PrintCustomCounselling
                        data={
                          allData?.defaultSaveItem[item?.id]
                            ?.renderCustomCounselingNineData
                        }
                        id={item?.id}
                      />
                    )) ||
                  (item?.variable_name === 'custom_counseling10' &&
                    item?.itemLink === 'show' && (
                      <PrintCustomCounselling
                        data={
                          allData?.defaultSaveItem[item?.id]
                            ?.renderCustomCounselingTenData
                        }
                        id={item?.id}
                      />
                    )) ||
                  (item?.variable_name === 'soap' &&
                    item?.itemLink === 'show' && (
                      <PrintRenderSoapNotePopUp
                        data={allData?.defaultSaveItem[item?.id]?.soapStr}
                        id={item?.id}
                      />
                    ))}
              </div>
            );
          }
          return null;
        })}

      <PrintFooter headerFooterInfo={allData?.printHeaderFooterInfo} />

      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <tbody>
          <tr>
            <td>
              {allData?.addendumList && allData?.addendumList.length > 0 && (
                <div
                  className="addendumBlock "
                  style={{ whiteSpace: 'pre-line' }}
                >
                  <p style={{ marginLeft: '9px', marginTop: '30px' }}>
                    <strong>Addendum:</strong>
                  </p>
                  {allData?.addendumList?.map((item, i) => {
                    return (
                      <div key={i}>
                        <p style={{ marginLeft: '15px', marginTop: '15px' }}>
                          <b>Provider Name & Credentials: </b>{' '}
                          {item?.ProviderDetail} <br />
                          <b>Original Note Date: </b> {item?.originalNote}{' '}
                          <br />
                          <b>Addendum Date: </b> {item?.addendumDate} <br />
                          <b>Added By: </b> {item?.addedBy} <br />
                          <b>Reason for Addendum: </b> <br />
                          <span
                            dangerouslySetInnerHTML={{ __html: item?.reason }}
                          />{' '}
                          <br />
                          <b>Additional Information: </b> <br />
                          <span
                            dangerouslySetInnerHTML={{
                              __html: item?.description,
                            }}
                          />
                        </p>
                        <br />
                        <br />
                      </div>
                    );
                  })}
                </div>
              )}
            </td>
          </tr>
        </tbody>
      </table>

      {/* <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{ color: '#000', paddingTop: 5, paddingLeft: 15 }}
            >
              {parse(allData?.coSignerStr)}
            </td>
          </tr>
        </tbody>
      </table> */}

      {/*<table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontWeight: 'bold', fontSize: 14, color: '#000' }}
              align="left"
            >
              Problem:
            </th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Presenting Problem:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              The clients presenting problems include grief from the death of
              father, emotional eating, anxiety, and depression.
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              History of Presenting Problem:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Client reported that his present problem had to do with his drug
              addiction, post traumatic-stress disorder, attention deficit
              hyperactivity disorder and depression. Aaron reported that he had
              made multiple attempts at recovery with subsequent relapses.
              Client reported having trouble maintaining his romantic and
              familial relationships due to his addiction as well as having
              trouble maintaining regular, gainful employment
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontSize: 14, fontWeight: 'bold', color: '#000' }}
              align="left"
            >
              Mental Exam:
            </th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Appearance:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Personal Hygiene:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Eye Contact:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Psycho Motor Activity:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Alert and Oriented:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Behavior:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Mood:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Affect:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Speech:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Thought Content:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Attention Span:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Memory:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Insight and Judgment:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Orientation:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Thought Process:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Perception:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Functional Status:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Within normal limits
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontSize: 14, fontWeight: 'bold', color: '#000' }}
              align="left"
            >
              Risk Assessment:
            </th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Suicidality:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Not Present, Ideation, Plan, Intent, Attempt, Past contemplation
              was listed though, Past attempts in 2013-2018, One past attempt a
              couple years ago; overdose, Past contemplation when clients
              ex-wife was murdered, Past attempt with overdosing 5 years ago
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Homicidality:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Not Present, Ideation, Plan, Intent, Attempt, Past contemplation
              was listed though, Past attempts in 2013-2018, One past attempt a
              couple years ago; overdose, Past contemplation when clients
              ex-wife was murdered, Past attempt with overdosing 5 years ago
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontSize: 14, fontWeight: 'bold', color: '#000' }}
              align="left"
            >
              Objective:
            </th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{ color: '#000', paddingTop: 5, paddingLeft: 15 }}
            >
              Client has reviewed all HIPAA and confidentiality documents
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontSize: 14, fontWeight: 'bold', color: '#000' }}
              align="left"
            >
              Psychiatric Treatment:
            </th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Have you or a family member been diagnosed with a psychiatric or
              mental illness?:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Not Present, Ideation, Plan, Intent, Attempt, Past contemplation
              was listed though, Past attempts in 2013-2018, One past attempt a
              couple years ago; overdose, Past contemplation when clients
              ex-wife was murdered, Past attempt with overdosing 5 years ago
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Have you taken or been prescribed antidepressants or other
              psychiatric medications?:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Not Present, Ideation, Plan, Intent, Attempt, Past contemplation
              was listed though, Past attempts in 2013-2018, One past attempt a
              couple years ago; overdose, Past contemplation when clients
              ex-wife was murdered, Past attempt with overdosing 5 years ago
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="734px"
        align="left"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ marginTop: 15 }}
      >
        <thead>
          <tr width="734px">
            <th
              width="734px"
              style={{ fontSize: 14, fontWeight: 'bold', color: '#000' }}
              align="left"
            >
              Trauma History:
            </th>
          </tr>
        </thead>
        <tbody>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Patient Experienced Trauma:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Not Present, Ideation, Plan, Intent, Attempt, Past contemplation
              was listed though, Past attempts in 2013-2018, One past attempt a
              couple years ago; overdose, Past contemplation when clients
              ex-wife was murdered, Past attempt with overdosing 5 years ago
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Patient Witnessed Trauma:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Not Present, Ideation, Plan, Intent, Attempt, Past contemplation
              was listed though, Past attempts in 2013-2018, One past attempt a
              couple years ago; overdose, Past contemplation when clients
              ex-wife was murdered, Past attempt with overdosing 5 years ago
            </td>
          </tr>
          <tr width="734px">
            <td
              width="719px"
              style={{
                fontWeight: 'bold',
                color: '#000',
                paddingTop: 15,
                paddingLeft: 15,
              }}
            >
              Trauma comments:
            </td>
          </tr>
          <tr width="734px">
            <td width="719px" style={{ paddingTop: 5, paddingLeft: 15 }}>
              Not Present, Ideation, Plan, Intent, Attempt, Past contemplation
              was listed though, Past attempts in 2013-2018, One past attempt a
              couple years ago; overdose, Past contemplation when clients
              ex-wife was murdered, Past attempt with overdosing 5 years ago
            </td>
          </tr>
        </tbody>
      </table> */}
    </>
  );
}

export default CounselingPrintPopup;
